<template>
  <section>
    <b-img
      center
      fluid
      :src="image.url"
      v-if="image !== undefined"
    ></b-img>
    <hr v-if="image !== undefined">
    <h5>{{ bulletin.title }}</h5>
    <p v-html="bulletin.content"></p>
    <b-list-group v-if="uncategorized_attachments.length > 0">
      <b-list-group-item
        class="d-flex justify-content-between align-items-center"
        v-for="attachment in uncategorized_attachments"
        :href="attachment.url"
      >
        {{ attachment.name }}
        <b-icon icon="cloud-download" font-scale="2"></b-icon>
      </b-list-group-item>
    </b-list-group>
    <social-sharing-button-toolbar
      :title="social_sharing_title"
      :to="social_sharing_route"
    ></social-sharing-button-toolbar>
  </section>
</template>

<script>
import Vue from 'vue'

import { IconsPlugin } from 'bootstrap-vue'
import { ImagePlugin } from 'bootstrap-vue'
import { ListGroupPlugin } from 'bootstrap-vue'

import SocialSharingButtonToolbar from '@/components/button-toolbars/SocialSharingButtonToolbar'

Vue.use(IconsPlugin)
Vue.use(ImagePlugin)
Vue.use(ListGroupPlugin)

export default {
  name: 'bulletin-info',
  props: {
    bulletin: {
      type: Object,
      require: true
    }
  },
  data() {
    return {
      // 
    }
  },
  computed: {
    image() {
      return this.bulletin.attachments
        ? this.bulletin.attachments.find(item => item.category === 'image')
        : undefined
    },
    uncategorized_attachments() {
      return this.bulletin.attachments
        ? this.bulletin.attachments.filter(item => item.category === null)
        : []
    },
    social_sharing_title() {
      return this.bulletin.title
    },
    social_sharing_route() {
      return { name: 'bulletin', params: { id: this.bulletin.id } }
    }
  },
  methods: {
    // 
  },
  created() {
    // alert(`Vue version : ${Vue.version}`)
    if (this.bulletin && this.bulletin.id) {
      gtag('event', `browse bulletin`, {
        code: this.bulletin.id,
        name: this.bulletin.title,
      })
    }
  },
  components: {
    SocialSharingButtonToolbar
  }  
}
</script>